export default __webpack_public_path__ + "static/media/cf.15c44127.svg";